import React from "react";
import styles from "./style.module.css";

const Dialog = ({ children, isShow, onClose, contentMode }) => {
  if (!isShow) return null;

  return (
    <div className={styles.dialog}>
      <div className={styles.dialogOverlay} onClick={onClose}></div>
      {contentMode === "built-in" ? (
        <div className={styles.centeredContent}>
          <div className={styles.dialogContent}>{children}</div>
        </div>
      ) : (
        <div className={styles.centeredContent}>{children}</div>
      )}
      <div className={styles.dialogBackdrop} onClick={onClose}></div>
    </div>
  );
};

export default Dialog;
